module.exports = __webpack_public_path__ + "static/media/akkurat-mono-webfont.32529621.woff";